/* zz-pdp-gallery.js — ZigZag mobile PDP gallery
   ≤740px: destroys the theme's mobile fade-Flickity and installs a native
   scroll-snap swipe gallery with dash indicators + tappable thumb strip.
   Desktop (>740px) is left entirely to the theme. Perfection Media 2026-07-19 */
(function () {
  var MQ = window.matchMedia('(max-width: 740px)');

  function setup(root) {
    root = root && root.querySelector ? root : document;
    var gal = root.querySelector('.js-product-gallery');
    if (!gal || !MQ.matches) return;
    var main = gal.querySelector('.js-carousel-main');
    if (!main || main.dataset.zzg) return;
    main.dataset.zzg = 'pending';

    var tries = 0;
    (function attempt() {
      var inst = window.Flickity && window.Flickity.data(main);
      if (inst) {
        try { inst.destroy(); } catch (e) {}
        finish();
      } else if (++tries < 40) {
        setTimeout(attempt, 100);
      } else {
        finish(); /* theme never initialised — apply layout anyway */
      }
    })();

    function cleanCells() {
      main.querySelectorAll('.carousel-cell').forEach(function (c) { c.style.cssText = ''; });
    }

    function finish() {
      main.dataset.zzg = '1';
      main.classList.add('zzg');
      cleanCells();
      gal.style.visibility = 'visible';

      var cells = [].slice.call(main.querySelectorAll('.carousel-cell'));

      /* if the theme re-initialises Flickity later (breakpoint events), kill it again */
      if (window.MutationObserver) {
        new MutationObserver(function () {
          if (!MQ.matches) return;
          var inst = window.Flickity && window.Flickity.data(main);
          if (inst && main.dataset.zzg === '1') {
            try { inst.destroy(); } catch (e) {}
            main.classList.add('zzg');
            cleanCells();
          }
        }).observe(main, { attributes: true, attributeFilter: ['class'] });
      }

      function scrollToCell(i) {
        var c = cells[i];
        if (!c) return;
        var target = c.getBoundingClientRect().left - main.getBoundingClientRect().left + main.scrollLeft;
        if (Math.abs(target - main.scrollLeft) < 2) return;
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce) { main.scrollLeft = target; return; }
        try { main.scrollTo({ left: target, behavior: 'smooth' }); }
        catch (e) { main.scrollLeft = target; }
        /* environments where smooth scrolling is inert: snap there directly */
        setTimeout(function () {
          if (Math.abs(main.scrollLeft - target) > 40) main.scrollLeft = target;
        }, 600);
      }

      /* dash indicators */
      var dEls = null;
      if (cells.length > 1 && !gal.querySelector('.zzg-dots')) {
        var dots = document.createElement('div');
        dots.className = 'zzg-dots';
        cells.forEach(function (c, i) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'zzg-dot';
          d.setAttribute('aria-label', 'Image ' + (i + 1));
          d.addEventListener('click', function () { scrollToCell(i); });
          dots.appendChild(d);
        });
        main.parentNode.insertBefore(dots, main.nextSibling);
        dEls = dots.children;
      }

      /* thumb strip: reuse the theme's thumbnails markup */
      var thumbs = gal.querySelector('#thumbnails');
      var tItems = [];
      if (thumbs) {
        var nav = thumbs.querySelector('.js-thumb-carousel-nav');
        var tf = nav && window.Flickity && window.Flickity.data(nav);
        if (tf) { try { tf.destroy(); } catch (e) {} }
        thumbs.classList.add('zzg-thumbs');
        tItems = [].slice.call(thumbs.querySelectorAll('.js-thumb-item'));
        tItems.forEach(function (t, i) {
          t.style.cssText = '';
          t.addEventListener('click', function () { scrollToCell(i); });
        });
      }

      /* active-state sync while swiping */
      function setActive(i) {
        if (dEls) [].forEach.call(dEls, function (d, j) { d.classList.toggle('is-active', j === i); });
        tItems.forEach(function (t, j) { t.classList.toggle('is-nav-selected', j === i); });
        var at = tItems[i];
        if (at && at.scrollIntoView) at.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      }
      if (window.IntersectionObserver) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting && en.intersectionRatio >= 0.6) setActive(cells.indexOf(en.target));
          });
        }, { root: main, threshold: 0.6 });
        cells.forEach(function (c) { io.observe(c); });
      }
      setActive(0);
    }
  }

  function boot() { setup(document); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('load', boot);
  document.addEventListener('shopify:section:load', function (e) { setup(e.target); });
})();
